const stats = [
  { value: "2", label: "iOS Products" },
];

export default function AboutSection() {
  return (
    <section id="about" className="py-24 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Label */}
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-gray-100 mb-8">
          <span className="text-xs font-semibold tracking-widest uppercase text-gray-500">Who We Are</span>
        </div>

        {/* Two-column layout */}
        <div className="flex flex-col lg:flex-row gap-16 lg:gap-24 items-start">
          {/* Left: Title */}
          <div className="lg:w-1/2">
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-gray-900 leading-tight tracking-tight">
              Expert Team<br />
              <span className="text-gray-400">Building the</span><br />
              Future of iOS
            </h2>
          </div>

          {/* Right: Description */}
          <div className="lg:w-1/2 flex flex-col justify-center">
            <p className="text-gray-600 text-base md:text-lg leading-relaxed mb-5">
              <strong>LIWAS d.o.o.</strong> is a Slovenia-based software company dedicated to developing high-quality applications for the iOS platform. Our team combines deep technical expertise with a passion for clean, intuitive design.
            </p>
            <p className="text-gray-600 text-base md:text-lg leading-relaxed mb-5">
              We believe that mobile security and device performance should be accessible to everyone. That&apos;s why our products are built with simplicity and effectiveness at their core — giving users powerful tools without complexity.
            </p>
            <p className="text-gray-600 text-base md:text-lg leading-relaxed">
              From encrypted VPN connections to intelligent device cleaning, every product we ship is crafted with precision, tested rigorously, and designed to deliver a seamless iOS experience.
            </p>
          </div>
        </div>

        {/* Stats */}
        <div className="mt-20 grid grid-cols-2 md:grid-cols-4 gap-8 border-t border-gray-100 pt-16">
          {stats.map((stat) => (
            <div key={stat.label} className="flex flex-col gap-2">
              <span className="text-4xl md:text-5xl font-extrabold text-gray-900 tracking-tight">{stat.value}</span>
              <span className="text-sm text-gray-500 font-medium">{stat.label}</span>
            </div>
          ))}
        </div>

        {/* Visual accent: team image */}
        <div className="mt-20 rounded-2xl overflow-hidden w-full h-64 md:h-96">
          <img
            src="https://public.readdy.ai/ai/img_res/a85528da71a3e18be2523ee43feab85c.jpg"
            alt="LIWAS d.o.o. development team"
            className="w-full h-full object-cover object-top"
          />
        </div>
      </div>
    </section>
  );
}
